"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Components_1 = require("./Components");
var PackIdentifier_1 = require("../../../../Types/PackIdentifier");
var Components_2 = require("../../Components");
require("Utils/Extensions");
var BarcodeScannerHandler_1 = require("../../../../Services/BarcodeScannerHandler");
var History_1 = require("../../../../Utils/History");
var EventHandlerService_1 = require("../../../../Services/EventHandlerService");
var Types_1 = require("../../../../Types");
var Types_2 = require("../../Types");
var SinglePackRequestService_1 = require("../../../../Services/SinglePackRequestService");
var Types_3 = require("../../../../Types");
var SignalR = require("@microsoft/signalr");
var Single = /** @class */ (function (_super) {
    __extends(Single, _super);
    function Single(props) {
        var _this = _super.call(this, props) || this;
        _this.parsePackData = function (json) {
            var headers = new Headers();
            headers.append("content-type", "application/json;");
            fetch("/Parser/Parse", {
                headers: headers,
                method: "post",
                body: json
            })
                .then(function (response) {
                return response.json();
            }).then(function (result) {
                if (result.submit) {
                    _this.setState({
                        packIdentifier: result,
                        currentState: 2 /* Sending */
                    }, function () {
                        SinglePackRequestService_1.SinglePackRequestService.SubmitPackRequest(result, _this.state.selectedAction, false, _this.props.applicationData.selectedLocation, _this.props.applicationData.resources).then(function (singlePackResult) {
                            _this.setState({
                                result: singlePackResult,
                                currentState: 3 /* Result */
                            });
                        }).catch(function (err) {
                            console.error(err);
                            _this.setState({
                                currentState: 4 /* Error */
                            });
                        });
                    });
                }
                else {
                    console.error("Display error");
                    _this.setState({
                        result: {
                            packInfo: {
                                Warning: _this.props.applicationData.resources.CannotParseBarcode
                            },
                            ragClass: "Red"
                        },
                        currentState: 3 /* Result */
                    });
                }
            });
        };
        _this.actionButtonOnClick = function (action) {
            if (_this.state.currentState === 1 /* Scanning */ || _this.state.currentState === 2 /* Sending */) {
                return;
            }
            if (action.value == Types_2.PackAction.MarkAsDestroyed.value || action.value == Types_2.PackAction.MarkAsStolen.value) {
                EventHandlerService_1.EventHandlerProvider.GetInstance().AddEvent(Types_1.ActionCannotBeUndone(_this.props.applicationData.resources, function () {
                    _this.setState({
                        selectedAction: action
                    });
                }));
            }
            else {
                _this.setState({
                    selectedAction: action
                });
            }
        };
        if (_this.props.applicationData.calibrationData == null) {
            EventHandlerService_1.EventHandlerProvider.GetInstance().AddEvent(Types_1.NeedToCalibrateScannerWarningEvent(_this.props.applicationData.resources));
            History_1.default.push('/Dashboard/Safe');
        }
        _this.barcodeScannerHandler = new BarcodeScannerHandler_1.BarcodeScannerHandler(_this.parseScannerInput.bind(_this));
        _this.scannedData = {};
        _this.state = {
            currentState: 0 /* Waiting */,
            packIdentifier: new PackIdentifier_1.PackIdentifier(),
            selectedAction: props.applicationData.availableActions && props.applicationData.availableActions.length != 0 ? props.applicationData.availableActions[0] : Types_2.PackAction.None,
            result: {}
        };
        document.addEventListener("keypress", _this.barcodeScannerHandler.keyPressHandler, true);
        document.addEventListener("keydown", _this.barcodeScannerHandler.keyDownHandler, true);
        document.addEventListener("keyup", _this.barcodeScannerHandler.keyUpHandler, true);
        return _this;
    }
    Single.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.applicationData.selectedLocation != this.props.applicationData.selectedLocation && this.props.applicationData.calibrationData == null) {
            History_1.default.push('/Dashboard/Safe');
        }
    };
    Single.prototype.componentWillUnmount = function () {
        document.removeEventListener("keypress", this.barcodeScannerHandler.keyPressHandler, true);
        document.removeEventListener("keydown", this.barcodeScannerHandler.keyDownHandler, true);
        document.removeEventListener("keyup", this.barcodeScannerHandler.keyUpHandler, true);
    };
    Single.prototype.parseScannerInput = function (dom3KeyboardEventCodeSupport) {
        var _this = this;
        if (this.props.applicationData.connectionState != SignalR.HubConnectionState.Connected) {
            EventHandlerService_1.EventHandlerProvider.GetInstance().AddEvent(new Types_3.VeriLiteWarningEvent(this.props.applicationData.resources.VeriLiteDisconnected));
            return;
        }
        if (this.state.currentState === 1 /* Scanning */ || this.state.currentState === 2 /* Sending */) {
            return;
        }
        if (dom3KeyboardEventCodeSupport) {
            this.scannedData = this.barcodeScannerHandler.scannerInput.getInput();
        }
        else {
            this.scannedData = this.barcodeScannerHandler.scannerInput.getInputBytes();
        }
        var scannedString = String.fromCharCode.apply(String, this.scannedData);
        if (this.scannedData.length > 20) {
            if (this.props.applicationData.calibrationData == null) {
                EventHandlerService_1.EventHandlerProvider.GetInstance().AddEvent(Types_1.NeedToCalibrateScannerWarningEvent(this.props.applicationData.resources));
                return;
            }
            this.setState({
                currentState: 1 /* Scanning */,
                packIdentifier: new PackIdentifier_1.PackIdentifier()
            }, function () {
                _this.parsePackData(JSON.stringify({ ScannedData: scannedString, CalibrationData: _this.props.applicationData.calibrationData }));
            });
        }
    };
    Single.prototype.render = function () {
        var _this = this;
        return (React.createElement(Components_2.DashboardPage, { content: React.createElement("div", null,
                React.createElement(Components_1.SingleForm, { currentState: this.state.currentState, packIdentifier: this.state.packIdentifier, resources: this.props.applicationData.resources }),
                this.state.currentState === 3 /* Result */ &&
                    React.createElement(Components_2.SinglePackResponse, { result: this.state.result, resources: this.props.applicationData.resources, showHelpLink: this.props.applicationData.showHelpLink, packIdentifier: this.state.packIdentifier })), actions: !Array.isNullOrEmpty(this.props.applicationData.availableActions) &&
                React.createElement("div", null, this.props.applicationData.availableActions.map(function (action) {
                    return React.createElement(Components_2.ActionButton, { key: action.value, action: action, onClick: function () { _this.actionButtonOnClick(action); }, active: _this.state.selectedAction == action });
                })), placeholder: this.props.applicationData.resources.ActionsWillAppear_Single, title: this.props.applicationData.resources.PackDetails, resources: this.props.applicationData.resources }));
    };
    return Single;
}(React.Component));
exports.Single = Single;
//# sourceMappingURL=Single.js.map